import './App.css';

import { ChakraProvider } from '@chakra-ui/react'
import Header from './components/Header';
import PageContent from './components/Content';

function App() {
  return (
    <ChakraProvider>
      <Header />
      <PageContent />
    </ChakraProvider>
  );
}

export default App;
